define( function() {
	"use strict";

	return ( /^$|\/(?:java|ecma)script/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rscriptType.js
// module id = 449
// module chunks = 243